import { defineStore } from 'pinia'
import { ref } from "vue"

export const useEnvironmentStore = defineStore( 'environmentStore', () => {
  const environment = ref( import.meta.env.MODE )

  function isProduction() {
    return environment.value === 'production';
  }

  return { environment, isProduction }
})